<template>
  <div>
    <b-modal
      id="modal-edit-project"
      ok-only
      ok-title="Edit"
      centered
      size="lg"
      title="Edit Project"
      :hide-footer="true"
    >
      <Editproject :project="currentProject" @projectAdded="closeEditProjectModal"  :assignee="assignee_options" />
    </b-modal>
    <!-- <div class="row justify-content-center">
      <div class="col-md-4">
        <b-card class="shadow-none bg-transparent border-secondary">
          <b-card-title> Number of Milestones </b-card-title>
          <h3>{{ this.milestonesTotal }}</h3>
        </b-card>
      </div>
      <div class="col-md-4">
        <b-card class="shadow-none bg-transparent border-success">
          <b-card-title> Number of Tasks </b-card-title>
          <h3>{{ this.tasksTotal }}</h3>
        </b-card>
      </div>
    </div> -->

    <b-card v-if="loading">
      <div class="d-flex justify-content-center">
        <b-spinner
          variant="success"
          label="Spinning"
          style="width: 3rem; height: 3rem"
        ></b-spinner>
      </div>
    </b-card>

    <b-card v-if="!loading">
      <b-card-body>
        <!-- <Editproject :project="currentProject" :actionType="'view'" /> -->
        <b-form>
          <b-row>
            <b-col md="4">
              <b-form-group label="Project Name" label-for="project-name">
                <b-form-input
                  id="project-name"
                  placeholder="No Name"
                  required
                  readonly
                  v-model="project.name"
                />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Approver" label-for="project_manager">
                {{ getApproverName(project.approverId) }}
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Customer" label-for="customer">
                <!-- <b-form-input
                  id="project-name"
                  placeholder="No Name"
                  required
                  readonly
                  v-model="project.customerName"
                />-->
                {{ getCustomerName(project.customerId) }}
              </b-form-group> 
            </b-col>

            <b-col md="4">
              <b-form-group label="Project Status" label-for="project-status">
                <b-form-input
                  id="project-status"
                  placeholder="No Status"
                  required
                  readonly
                  v-model="project.status"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Progress" label-for="Progress">
                <b-form-input
                  id="Progress"
                  placeholder="No Progress"
                  required
                  readonly
                  v-model="project.progress"
                />
              </b-form-group>
            </b-col>

            <!-- <b-col md="4">
              <b-form-group label="Progress %" label-for="percentage">
                <b-form-input
                  id="percentage"
                  placeholder="No Progress"
                  required
                  readonly
                  v-model="project.percentage"
                />
              </b-form-group>
            </b-col> -->
            <b-col md="4">
              <b-form-group label="Priority" label-for="Priority">
                <b-form-input
                  id="Priority"
                  placeholder="No Priority"
                  required
                  readonly
                  v-model="project.priority"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Start Date" label-for="Start-Date">
                <b-form-datepicker
                  class="mb-1"
                  v-model="project.startDate"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="End Date" label-for="End-Date">
                <b-form-datepicker
                  class="mb-1"
                  v-model="project.endDate"
                  disabled
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Description" label-for="description">
                <b-form-textarea
                  id="description"
                  placeholder="Description of project "
                  rows="1"
                  required
                  readonly
                  v-model="project.description"
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Budget" label-for="budget">
                <b-form-input
                  id="budget"
                  v-model="project.budget"
                  type="number"
                  readonly

                  
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Expense" label-for="expense">
                <b-form-input
                  id="expense"
                  v-model="project.expense"
                  type="number"
                  readonly
                  
                />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Estimates" label-for="estimates">
                <b-form-input
                  id="estimates"
                  v-model="project.estimates"
                  type="number"
                  readonly
                />
              </b-form-group>
            </b-col>

            <b-col md="12" class="d-flex justify-content-end">
              <b-button
                variant="primary"
                v-b-modal.modal-edit-project
                @click="editProject(project)"
              >
                Edit
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <b-card v-if="project.status !== 'REMOVED'">
      <h3>Milestones</h3>
      <b-card-body>
        <MilestonesList
          :projectId="this.id"
          @updateMilestoneCount="handleMilestoneCount"
        />
      </b-card-body>
    </b-card>

    <b-card v-if="project.status !== 'REMOVED'">
      <h3>Tasks</h3>
      <b-card-body>
        <TaskList :projectId="this.id" @updateTasksCount="handleTaskCount" />
      </b-card-body>
    </b-card>

    <b-card v-if="project.status !== 'REMOVED'">
      <b-card-body>
        <CostListPerProject />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
  BCard,
  BCardBody,
  BCardTitle,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import MilestonesList from "./MilestonesList.vue";
import TaskList from "./TasksList.vue";
import CostListPerProject from "./CostTablePerProject.vue";
import Editproject from "./EditProject.vue";
import { HasPermission } from "@/@core/utils/validations/permissionCheck";
import { PermissionList } from "@/libs/defaultList";

export default {
  name: "AddProject",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    BCard,
    BCardBody,
    TaskList,
    BCardTitle,
    MilestonesList,
    Editproject,
    CostListPerProject,
  },

  props: {},

  data() {
    return {
      id: this.$route.params.id,
      project: {},
      tasksTotal: 0,
      milestonesTotal: 0,
      assignee_options: [],
      defaultTask: {
        title: "",
        description: "",
        startDate: "",
        endDate: "",
        assignee: "",
        assigneeName: "",
        priority: "NOTSPECIFIED", // Set default priority
        status: "NOTSTARTED", // Set default status
        projectId: this.$route.params.id,
      },
      assetCode: "",
      project_name: "Project Name 1",
      projectId: this.$route.params.id,
      project_description: "Description of project will appear here",
      purchaseDate: null,
      lifeEndDate: null,
      maintainanceDate: null,
      location: "",
      selected: 1,
      costPerHour: 0,
      optionsCustomer: [],
      currentProject: null,
      projectManagerOptions: [
        { value: "Staff1", text: "Staff 1" },
        { value: "Staff2", text: "Staff 2" },
        { value: "Staff3", text: "Staff 3" },
      ],
      options: [
        { value: null, text: "Please select an option" },
        { value: 1, text: "Customer 1" },
        { value: 2, text: "Customer 2" },
        { value: 3, text: "Customer 3" },
        { value: 4, text: "Customer 4" },
        { value: 5, text: "Customer 5" },
      ],
    };
  },

  methods: {
    ...mapActions("customerModule", ["getCustomersListAction"]),
    ...mapActions("projectModule", [
      "getProjectByIdAction",
      "getProjectListAction",
      "getProjectAssigneesAction",
    ]),
    handleTaskCount(count) {
      this.tasksTotal = count;
    },
    handleMilestoneCount(count) {
      this.milestonesTotal = count;
    },
    getApproverName(id) {
      const assignee = this.assignees.find((option) => option.id === id);
      return assignee ? `${assignee.firstName} ${assignee.lastName}` : "-";
    },

   getCustomerName(id) {
  const cust = this.CustomerList.find(c => c.id === id);

  if (!cust) return "-";

  const other = cust.otherName || "";
  const sur = cust.surname || "";

  const fullName = `${other} ${sur}`.trim();

  return fullName || "-";
},

    editProject(project) {
      this.currentProject = { ...project };
      this.$bvModal.show("modal-edit-project");
    },
    async viewProject(project) {
      this.currentProject = project;
      this.currentProject.percentage =
        project.tasks.percentageTaskCompletion.toFixed(2);
      this.$bvModal.show("modal-view-project");
    },
    async closeEditProjectModal() {
      this.$bvModal.hide("modal-edit-project");

      await this.getProjectByIdAction(this.id)
      .then((response) => {
        this.project = this.proj;
        console.log("this.project", this.project);
        if (this.project.status === "REMOVED") {
          this.project.status = "REMOVED";
        }
      })
      .catch((response) => {
        console.log(response);
      });

    },
    async formSubmitted() {
      let isValid = await this.$refs.AddForm.validate();
      if (isValid) {
        let loader = customLoader(
          "Please wait while the project is being added"
        );

        this.project.approverName = this.assignee.filter(
          (x) => x.value === this.project.approverId
        )[0].text;
        let payload = {
          ...this.project,
        };

        const selectedCustomer = this.optionsCustomer.find(
          (customer) => customer.value === this.project.customerId
        );

        if (selectedCustomer) {
          payload.customerName = selectedCustomer.text;
        }
        this.updateProjectAction(payload)
          .then(() => {
            loader.close();
            customSwal("You have successfully updated the project!");
            this.$emit("projectAdded");
          })
          .catch((ex) => {
            loader.close();
            customError(ex.response.data);
            this.$emit("projectAdded");
          });
      }
    },
  },
  computed: {
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      loadingCustomer: "loading",
    }),
    ...mapGetters("projectModule", {
      proj: "projectId",
      assignees: "assignees",
      loading: "loading",
    }),
  },

  async mounted() {
    this.project = {};
    if (HasPermission(PermissionList.Sales_View)) {
      await this.getCustomersListAction().then(() => {
        this.optionsCustomer = this.CustomerList.map((customer) => ({
          value: { id: customer.id, name: customer.otherName },
          text: `${customer.otherName} ${customer.surname ?? ''}`,
        }));
      });
    }

    await this.getProjectByIdAction(this.id)
      .then((response) => {
        this.project = this.proj;
        console.log("this.project", this.project);
        if (this.project.status === "REMOVED") {
          this.project.status = "REMOVED";
        }
      })
      .catch((response) => {
        console.log(response);
      });

    await this.getProjectAssigneesAction();
    this.assignee_options = this.assignees.map((assignee) => ({
      value: assignee.id,
      text: `${assignee.firstName} ${assignee.lastName}`,
    }));

    //View Projects
    let userData = JSON.parse(localStorage.getItem("userData"));
    this.userId = userData.id;
    // await this.getProjectListAction()
    //   .then((response) => {
    //     this.totalRows = this.projects.length;
    //   })
    //   .catch((response) => {
    //     console.log(response);
    //   });

    // await this.getProjectAssigneesAction();
    // this.assignee_options = this.assignees.map((assignee) => ({
    //   value: assignee.id,
    //   text: `${assignee.firstName} ${assignee.lastName}`,
    // }));
  },
  setup() {
    return {
      HasPermission,
      PermissionList,
    };
  },
};
</script>
